/**
 * Batas atas umur rekaman, hari (§D6).
 *
 * Kembaran `RETENSI_MAX_HARI` di `backend/src/services/retentionPolicy.ts`,
 * yang memegang alasan lengkapnya. Singkatnya: NAS punya cron retensinya
 * sendiri yang menghapus berkas rekaman lewat sebulan, di luar Lensa dan tanpa
 * membaca DB. Di atas 30 hari, yang menghapus rekaman bukan lagi aplikasi ini —
 * jadi angkanya bukan setelan yang bisa ditepati, melainkan janji palsu.
 *
 * Ada dua salinan angkanya karena frontend memang tidak pernah mengimpor kode
 * backend di repo ini (lihat batas segmen dan port, yang juga ditulis dua kali).
 * Yang memutuskan tetap server: kalaupun salinan di sini basi, permintaannya
 * ditolak di sana. Yang dikerjakan angka ini cuma **mencegah orang mengetik
 * sesuatu yang akan ditolak** — dan mengatakan kenapa sebelum mereka menekan
 * Simpan, bukan sesudahnya.
 */
export const RETENSI_MAX_HARI = 30;
